import axios from 'axios';
import AuthService from 'services/Auth';
import UIHelper from 'helpers/UIHelper';

class PDFApi {
  constructor(resource = '') {
    const apiUrl = process.env.REACT_APP_PDF_APP_URL;
    this.url = `${apiUrl}`;
  }

  getPdf = (url) => {
    return axios({
      url: this.url,
      method: 'get',
      data: {
        url,
      },
      params: {
        url,
      },
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default PDFApi;
